/* note to self - find out what this does and probably rewrite it */
/*****************************************************
* 
*	Jurisdiction selector
* 
*****************************************************/

	ele.jurisdiction = {
		//Initiate Jurisdicton selector
        textFilter: "",
		initSelector: function(){
			var $jurisdictionSelector = $('#jurisdictionSelector');
			var wto;

            //change listener
            $jurisdictionSelector.change(function(){
                $('.e_productsGlobal, .e_products').removeClass('sHidden');
                $('.e_products table').removeClass('sHidden');
                $('.e_noDocsInJurisdiction').addClass('sHidden');

                var originalProducts = document.querySelectorAll(".e_productsGlobal, .e_products");
                for (var i = 0; i < originalProducts.length; i ++) {
                    originalProducts[i].classList.remove('sHidden');
                }
                //Run filter to show/hide products
                ele.jurisdiction.filter($jurisdictionSelector.val());
                //jurisdiction selection saved on session
                if (ele.config.jurisdictions.selectJurisdictionBeforeShowingProducts) {
                    if ($jurisdictionSelector.val() == '-') {
                        for (var i = 0; i < originalProducts.length; i ++) {
                            originalProducts[i].classList.add('sHidden');
                        }
                    } else {
                        if ($jurisdictionSelector.val() !== null) {
                            for (var i = 0; i < originalProducts.length; i ++) {
                                originalProducts[i].classList.remove('sHidden');
                            }
                        }
                    }
                    
                    clearTimeout(wto);
                    wto = setTimeout(function() {
                        if ($jurisdictionSelector.val() != '-' && $jurisdictionSelector.val() !== null) {
                            jQuery.post('..' + ele.config.directory + '/index.cfm?event=storeJurisdictionInSession', {jurisdictionID: $('#jurisdictionSelector').val()})
                        }
                    }, 3000);
                }
            });

            //find the initial value set by server and load onto dropdown
            let initialJurisdiction = ele.config.jurisdictions.initialJID;
            let searchRegEx = new RegExp('search')
            if (initialJurisdiction === null || initialJurisdiction === 0 && ele.config.jurisdictions.selectJurisdictionBeforeShowingProducts || ele.config.jurisdictions.selectJurisdictionBeforeShowingProducts && !ele.config.jurisdictions.jurisdictionSetProperlyAtRegistration) initialJurisdiction =  "-";

            // Don't do this on the search page as the whole thing reloads so this would keep you trapped on your starting region
            if(!searchRegEx.test(ele.config.usersession.event)){
                $jurisdictionSelector.val(initialJurisdiction).change();
            }

			//we've also tacked on a little product text filter too. listener for this
            if(!!document.getElementById("productListFilter")) {
                $("#productListFilter").on("keyup", function (e) {
                    ele.jurisdiction.textFilter = $("#productListFilter").val();
                    $jurisdictionSelector.change();
                });
            }

		},

        updateSubcategoryHeaderVisibility: function() {
            // For each products table on the page…
            $('.e_products table').each(function () {
              const $table = $(this);
          
              // If any visible product rows exist anywhere in the table,
              // we’ll mark the table as visible; else we hide the table.
              const anyVisibleProducts = $table
                .find('tr.e_product')
                .filter(function () {
                  // treat both explicit display:none and our .sHidden class as hidden
                  return $(this).is(':visible') && !$(this).hasClass('sHidden');
                }).length > 0;
          
              $table.toggleClass('sHidden', !anyVisibleProducts);
          
              // For each subcategory header, hide it if *all* its product rows are hidden
              $table.find('tr.subcat').each(function () {
                const subcatId = $(this).data('subcat');
                const visibleInSubcat = $table
                  .find(`tr.e_product[data-subcat="${subcatId}"]`)
                  .filter(function () {
                    return $(this).is(':visible') && !$(this).hasClass('sHidden');
                  }).length;
          
                $(this).toggleClass('sHidden', visibleInSubcat === 0);
              });
            });
        },

        checkTableVisibility: function () {
            let anyTableVisible = false;
          
            // Subscription / main product table(s)
            $('.e_products table').each(function () {
              const $table = $(this);
              const visibleProducts = $table.find('tr.e_product')
                .filter(function () {
                  return $(this).is(':visible') && !$(this).hasClass('sHidden');
                }).length;
          
              $table.toggleClass('sHidden', visibleProducts === 0);
              if (visibleProducts > 0) anyTableVisible = true;
            });
          
            $('.ele-subsiteProducts .e_productCategories').each(function() {
              let id = $(this).attr('id');
              $(`#quick_link_${id}`).removeClass('sHidden'); 
              $(this).removeClass('sHidden');
              // log if this is hidden
              console.log($(this).hasClass('sHidden'));
              $('.category-menu-button').removeClass('sHidden');
          
              const visibleChildren = $(this).find('.e_productsGlobal .e_product:not(.sHidden)');
              console.log(visibleChildren);

              if (visibleChildren.length === 0) {
                $(this).addClass('sHidden');
                if ($(`#tab-control-${id}`).hasClass('active')) {
                  $('#all-tab').trigger('click');
                }
                $(`#tab-control_${id}, #quick_link_${id}`).addClass('sHidden');
              } else {
                anyTableVisible = true;
              }
            });
          
            // Related products (unchanged) …
            if ($('#e_relatedServices').length) {
              const relatedServices = $('#e_relatedServices .relatedContainer .e_products').find('.e_product:visible');
              if (relatedServices.length > 0) anyTableVisible = true; 
            }
          
            // NEW: ensure subcategory titles track current visibility
            this.updateSubcategoryHeaderVisibility();
          
            // Empty-state message
            if (!anyTableVisible) {
              if ($('#jurisdictionSelector').val() !== '-') {
                $('.e_noDocsInJurisdiction').removeClass('sHidden');
              }
            } else {
              $('.e_noDocsInJurisdiction').addClass('sHidden');
            }
          },          

		//To filter a product list by jurisdiction
		filter: function(jid){
			if( $('.e_jurItem').length ){

                var allProducts = document.querySelectorAll('.e_jurItem');

                for (var i = 0; i < allProducts.length; i ++) {
                    if(jid != 0){
                        allProducts[i].classList.add('sHidden');
                    } else {
                        allProducts[i].classList.remove('sHidden');
                    }
                }
                
                if(!!document.getElementById("productListFilter")) {

                    var chosenProducts = document.querySelectorAll(".e_jurId_" + jid);

                    for (var i = 0; i < chosenProducts.length; i ++) {
                        if(ele.jurisdiction.textFilter != ""){
                            var textName = chosenProducts[i].firstElementChild["textContent"].toLowerCase();
                            if(textName.indexOf(ele.jurisdiction.textFilter.toLowerCase()) > -1){
                                chosenProducts[i].classList.remove('sHidden');
                            }
                        } else {
                            chosenProducts[i].classList.remove('sHidden');
                        }
                    }

                } else {
                    var chosenProducts = document.querySelectorAll(".e_jurId_" + jid);
                    for (var i = 0; i < chosenProducts.length; i ++) {
                        chosenProducts[i].classList.remove('sHidden');
                    }
                }

			}
			// If there are no docs in this jurisdiction and category, hide the category
      ele.jurisdiction.checkTableVisibility();
		}
	};
	//Call Jurisdiction initiation
	$('document').ready(function(){
		if ($('#jurisdictionSelector').length > 0 && $('#jurisdictionSelector').is(":visible")){
			ele.jurisdiction.initSelector();
		}
	});
